var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame250(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1760_331964)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8967 13.5727C12.821 13.5727 5.46373 20.8555 5.46373 29.8394V31.4798C5.46373 33.6188 7.21547 35.3528 9.37635 35.3528H10.6139C11.8916 35.3528 12.9347 34.3414 12.961 33.0768L12.9784 32.2385C12.9843 31.957 13.144 31.7008 13.3955 31.5694C13.647 31.438 13.9508 31.452 14.1888 31.606L15.4758 32.4385C19.3769 34.9619 24.4166 34.9619 28.3176 32.4385L29.6046 31.606C29.8427 31.452 30.1465 31.438 30.398 31.5694C30.6495 31.7008 30.8092 31.957 30.815 32.2385L30.8325 33.0768C30.8588 34.3414 31.9019 35.3528 33.1796 35.3528H34.4171C36.578 35.3528 38.3297 33.6188 38.3297 31.4798V29.8394C38.3297 20.8555 30.9724 13.5727 21.8967 13.5727ZM3.89868 29.8394C3.89868 19.9999 11.9567 12.0234 21.8967 12.0234C31.8368 12.0234 39.8948 19.9999 39.8948 29.8394V31.4798C39.8948 34.4744 37.4424 36.9021 34.4171 36.9021H33.1796C31.2336 36.9021 29.6141 35.4942 29.316 33.6433L29.1738 33.7353C24.7525 36.5952 19.0409 36.5952 14.6197 33.7353L14.4775 33.6433C14.1794 35.4942 12.5599 36.9021 10.6139 36.9021H9.37635C6.35112 36.9021 3.89868 34.4744 3.89868 31.4798V29.8394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1149 9.28976C9.80869 9.69725 0.769287 18.8987 0.769287 30.1901V32.2595C0.769287 36.1097 3.92242 39.2309 7.812 39.2309H35.9829C39.8725 39.2309 43.0256 36.1097 43.0256 32.2595V30.1901C43.0256 18.8987 33.9862 9.69725 22.68 9.28976V6.19336H21.1149V9.28976ZM21.8974 10.8249C11.093 10.8249 2.33434 19.495 2.33434 30.1901V32.2595C2.33434 35.2541 4.78677 37.6817 7.812 37.6817H35.9829C39.0081 37.6817 41.4605 35.2541 41.4605 32.2595V30.1901C41.4605 19.495 32.7018 10.8249 21.8974 10.8249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8989 2.31875C21.0345 2.31875 20.3338 3.01236 20.3338 3.86797C20.3338 4.72358 21.0345 5.41718 21.8989 5.41718C22.7633 5.41718 23.464 4.72358 23.464 3.86797C23.464 3.01236 22.7633 2.31875 21.8989 2.31875ZM18.7688 3.86797C18.7688 2.15675 20.1702 0.769531 21.8989 0.769531C23.6276 0.769531 25.029 2.15675 25.029 3.86797C25.029 5.57919 23.6276 6.9664 21.8989 6.9664C20.1702 6.9664 18.7688 5.57919 18.7688 3.86797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.6584,
    cy: 25.3408,
    rx: 2.13666,
    ry: 2.13666,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.6157,
    cy: 25.3408,
    rx: 2.13665,
    ry: 2.13666,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1760_331964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.8462,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame250);
export default __webpack_public_path__ + "static/media/Frame250.e88cf2383dc02b0b73af102fa740341a.svg";
export { ForwardRef as ReactComponent };